import UserSystemRole from "../components/UserSystemRole";
import { saveData } from "./store-data";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  CLIENT_PROFILE_CODE,
  PROFILE_LOGIN,
  USER_ID,
  LOGIN_BY,
  USER_EMAIL,
} from "./store-data-constants";
import { loginByEmail } from "./Constants";

/**
 * Single source of truth for "where does a logged-in user go next".
 * Call this after you've confirmed the account isn't deleted/disabled.
 *
 * @param {object} user     - the `data` object from any login API response
 * @param {function} navigate
 * @param {object} [opts]
 * @param {string}  [opts.email]   - pass when logging in via email/Google, needed for temp-registered flows
 * @param {boolean} [opts.replace] - whether to replace history entry (default true)
 */
export const routeUserAfterLogin = async (user, navigate, opts = {}) => {
  console.log(user);

  const { email, replace = true } = opts;

  await saveData(USER_ID, user.UserId);

  // User signed up but hasn't finished onboarding yet
  if (user.IsTempRegistered && user.LoginBy === loginByEmail) {
    if (email) {
      await saveData(LOGIN_BY, loginByEmail);
      await saveData(USER_EMAIL, email);
    }
    if (user.SystemRole === UserSystemRole.AGENT.id) {
      navigate("/business_setup");
    } else if (user.SystemRole === UserSystemRole.CLIENT.id) {
      navigate("/client_setup");
    }
  }

  if (user.SystemRole === UserSystemRole.AGENT.id) {
    await saveData(AGENT_LOGIN, true);
    await saveData(PROFILE_LOGIN, false);
    await saveData(CLIENT_LOGIN, false);
    navigate("/dashboard", { replace });
    return;
  }

  if (user.SystemRole === UserSystemRole.CLIENT.id) {
    if (user?.client?.ParentId) {
      await saveData(AGENT_LOGIN, false);
      await saveData(PROFILE_LOGIN, false);
      await saveData(CLIENT_LOGIN, true);
      navigate("/dashboard", { replace });
    } else {
      await saveData(AGENT_LOGIN, false);
      await saveData(CLIENT_LOGIN, false);
      await saveData(PROFILE_LOGIN, true);
      await saveData(CLIENT_PROFILE_CODE, user.profile.ClientCode);
      navigate("/profileforclient", {
        replace,
        state: { client: user.profile },
      });
    }
    return;
  }

  console.log(
    "is client ",
    Number(user.SystemRole) === UserSystemRole.PROFILE.id,
  );

  if (Number(user.SystemRole) === UserSystemRole.PROFILE.id) {
    if (user?.profile?.IsProfileActivated) {
      await saveData(AGENT_LOGIN, false);
      await saveData(CLIENT_LOGIN, false);
      await saveData(PROFILE_LOGIN, true);
      await saveData(CLIENT_PROFILE_CODE, user.profile.ClientCode);
      navigate("/profileforclient", { state: { client: user.profile } });
    } else {
      navigate("/profilelogin",{replace:true});
    }
    return;
  }

  // Unknown/unexpected role
  alert("Invalid login. Please try again.");
  navigate("/home");
};
